import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class DialogComponent implements OnInit {

  messages!: string;
  confirmText!: string;
  cancelText!: string;
  showCancel = true;

  constructor(
    private readonly dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any)
  { }

  ngOnInit() {
    this.messages = this.data.messages
    this.confirmText = this.data.confirmText || 'Confirmar'
    this.cancelText = this.data.cancelText || 'Cancelar'
    if (this.data.showCancel !== undefined)
      this.showCancel = this.data.showCancel
  }

  public handleConfirm() {
    this.close({ confirm: true });
  }

  public handleCancel() {
    this.close({ confirm: false });
  }

  private close(result: any) {
    this.dialogRef.close(result);
  }

}
